/**
 * DataSourceConfig 不可更改
 */
import {IDataSourceConfig} from '../../../interface/file';

export class DataSourceConfig {

  constructor(private _option: IDataSourceConfig) {

  }

  /**
   * 数据源id
   */
  get id() {
    return this._option.id;
  }

  /**
   * 数据源名称
   */
  get name() {
    return this._option.name;
  }

  /**
   * 数据源生成器所在的库名
   */
  get repositoryID() {
    const [id] = this._option.generatorPath.split('$');
    return id;
  }

  /**
   * 数据源生成器路径URI   repositoryID$generatorID
   */
  get generatorPath() {
    return this._option.generatorPath;
  }

  /**
   * 数据源生成器参数
   */
  get generatorParams() {
    return this._option.generatorParams;
  }

  get dataType(): string {
    return this._option.meta.dataType;
  }

  get dimensions() {
    return this._option.meta.dimensions;
  }

  get value(): IDataSourceConfig {
    return this._option;
  }
}
